module.exports = __webpack_public_path__ + "static/img/shangcheng.555426ff.png";